// eslint-disable-next-line no-restricted-imports -- used to override Next.js Link behavior
import Link, { type LinkProps } from 'next/link'
import { type ComponentProps, type FC } from 'react'

export type NextLinkProps = LinkProps &
  Omit<ComponentProps<'a'>, keyof LinkProps>

/**
 * Link wrapper disabling Next.js prefetch by default (extend as needed).
 *
 * Prefetching disabling rationale:
 * - Most pages are dynamic; prefetch adds little value.
 * - App Router layouts and Server Components are not widely adopted yet.
 *
 * Re-enable prefetch once we have evidence of a navigation performance benefit.
 *
 * Reference: https://nextjs.org/docs/app/guides/prefetching#disabled-prefetch
 */
export const NextLink: FC<NextLinkProps> = (props) => (
  <Link prefetch={false} {...props} />
)
